import React, { type HTMLAttributes, type ReactElement } from "react";
import { PersonListItem } from "@/components";
import type { ObservatoryPerson } from "@/types";

interface PersonListProps extends HTMLAttributes<HTMLDivElement> {
  data: ObservatoryPerson[];
}

function PersonList({ data }: Readonly<PersonListProps>): ReactElement {
  return (
    <ul className="flex flex-col gap-2">
      {data.map((item): ReactElement => {
        const person = item.person;
        return (
          <li key={person.id}>
            <PersonListItem person={person} />
          </li>
        );
      })}
    </ul>
  );
}

export { PersonList, type PersonListProps };
